(function () {
  'use strict';

  if (window.__vmaxResultsControlsInitialized) return;
  window.__vmaxResultsControlsInitialized = true;

  var controlSelector = '[data-vmax-results-page-size]';
  var navigationPending = false;

  function applyPageSize(select) {
    if (!select || navigationPending) return;

    var pageSize = parseInt(select.value, 10);
    if ([18, 24, 36, 72, 250].indexOf(pageSize) === -1) return;

    var url = new URL(window.location.href);
    url.searchParams.set('view', String(pageSize));
    url.searchParams.delete('page');

    if (url.toString() === window.location.href) return;

    navigationPending = true;
    window.location.assign(url.toString());
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches(controlSelector)) {
      applyPageSize(event.target);
    }
  });

  if (window.jQuery) {
    window.jQuery(document)
      .off('select2:select.vmaxResultsPageSize', controlSelector)
      .on('select2:select.vmaxResultsPageSize', controlSelector, function () {
        applyPageSize(this);
      });
  }

  window.addEventListener('pageshow', function () {
    navigationPending = false;
  });
})();
